module.exports = __webpack_public_path__ + "static/media/aws.60b34a7e.svg";